import { Department } from './index';

export interface UserSettings {
  language: string;
  timeZone: string;
  notifications: {
    email: boolean;
    push: boolean;
    digest: boolean;
  };
  theme: 'light' | 'dark' | 'system';
  compactView: boolean;
  autoRefresh: boolean;
  refreshInterval: number;
  desktopNotifications: boolean;
  soundAlerts: boolean;
  taskReminders: boolean;
  urgentAlertsOnly: boolean;
}

export const defaultUserSettings: UserSettings = {
  language: 'en-US',
  timeZone: 'America/Los_Angeles',
  notifications: {
    email: true,
    push: true,
    digest: true,
  },
  theme: 'light',
  compactView: false,
  autoRefresh: true,
  refreshInterval: 60,
  desktopNotifications: true,
  soundAlerts: true,
  taskReminders: true,
  urgentAlertsOnly: false,
};